import { LIST_USER_LEVEL, LIST_USER_ROLE } from "constant/user";
import { validatePassword } from "constant/validation";
import * as Yup from "yup";

export const convertRoleCodeToListLevel = (role) => {
  const listLevelCodeByRole = LIST_USER_ROLE.find(
    (item) => item.roleName === role
  )?.levels;
  if (!listLevelCodeByRole) return [];
  return listLevelCodeByRole.map((roleCode) =>
    LIST_USER_LEVEL.find((item) => item.value === roleCode)
  );
};

export const userValidationSchema = Yup.lazy((values) => {
  const isEdit = !!values.id;
  const { level } = values;

  return Yup.object().shape({
    username: Yup.string().required("Không được trống"),
    password: validatePassword(!isEdit),
    role: Yup.string().required("Không được trống"),
    level: Yup.string().required("Không được trống"),
    ...((level === "city" ||
      level === "district" ||
      level === "postoffice") && {
      city: Yup.string().required("Không được trống"),
    }),
    ...((level === "district" || level === "postoffice") && {
      district: Yup.string().required("Không được trống"),
    }),
    ...(level === "postoffice" && {
      postoffice: Yup.string().required("Không được trống"),
    }),
    fullname: Yup.string().required("Không được trống"),
    loginType: Yup.number().required("Không được trống"),
    email: Yup.string()
      .required("Không được trống")
      .email("Sai định dạng email"),
  });
});
